module.exports = __webpack_public_path__ + "media/images/firma-1d024ee4651bf17d619814927f40eecb.jpeg";